import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo";

import { siteStore } from "src/js/stores/site/store";
import { useSnapshot } from "valtio/react";
import { useWorkspaceQuery } from "@gql/sites-api/graphql";

type UseSelectedWorkspaceQueryParams = {
  forceUpdateLastOpenedDate: boolean;
};

export function useSelectedWorkspaceQuery(params?: UseSelectedWorkspaceQueryParams) {
  const { forceUpdateLastOpenedDate = false } = params ?? {};
  const { selectedWorkspaceId } = useSnapshot(siteStore);

  const { data, ...queryState } = useWorkspaceQuery({
    variables: {
      workspaceId: selectedWorkspaceId as string,
    },
    skip: !selectedWorkspaceId,
    client: routedClient,
    context: {
      endpoint: LandTechEndpoints.Sites,
    },
    // If we want to update the last opened date, we need to hit the network.
    fetchPolicy: forceUpdateLastOpenedDate ? "cache-and-network" : "cache-first",
  });

  return {
    selectedWorkspace: data?.workspace,
    ...queryState,
  };
}
